import React, { FC } from 'react';
import { SwitchInput } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

export interface ISwitchInputWrapper extends FieldRenderProps<boolean> {}

const SwitchInputWrapper: FC<ISwitchInputWrapper> = (props) => {
  const { input, meta, label, children, render, ...otherProps } = props;
  return <SwitchInput label={label} {...input} {...otherProps} />;
};

export default SwitchInputWrapper;
